import {getNumberForRingpools} from '../ringpool';
import {formatPhoneNumber, ringpoolsToMap} from './helpers.js';

export const runCustomNativeRingpool = () => {
    const ringpoolNumbers = Array.from(document.querySelectorAll('[data-ringpool-id]'));
    const rpids = ringpoolNumbers.map(node => node.dataset.ringpoolId).filter((rpid, index, arr) => arr.indexOf(rpid) === index);
    const phoneButton = document.querySelector('[data-ringpool-phone]');

    if (rpids.length > 0) {
        getNumberForRingpools(rpids)
            .then(ringpools => ringpoolsToMap(ringpools))
            .then(mappedRingpools => {
                ringpoolNumbers.forEach(node => {
                    const rpid = node.dataset.ringpoolId;
                    const tfn = mappedRingpools[rpid];
                    const altFormat = node.dataset.altFormat;
                    const ga = node.dataset.ga;
                    if (typeof (tfn) !== 'undefined' && typeof(ga) !== 'undefined' && ga === 'referral-call') {
                        // finally, set the phone number in the DOM node, and we're done!
                        node.setAttribute('href', `tel:${tfn}`);
                        node.innerHTML = node.innerHTML.replace(/\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/, formatPhoneNumber(tfn, altFormat));
                    }
                });
                // only need to check first phone button if ringpool is loaded
                if (phoneButton !== null) {
                    phoneButton.dispatchEvent(new CustomEvent('ringPoolType1Loaded', {}));
                    console.log('Ringpool custom native typeid 1 numbers loaded...');
                }
            });

        // 2nd Call to get unique phone numbers for child pages tracking (typeid = 2)
        getNumberForRingpools(rpids, 2)
            .then(ringpoolsType2 => ringpoolsToMap(ringpoolsType2))
            .then(mappedRingpoolsType2 => {
                ringpoolNumbers.forEach(node => {
                    const rpid = node?.dataset.ringpoolId;
                    const tfn = mappedRingpoolsType2[rpid];
                    if (typeof (tfn) !== 'undefined') {
                        if (node) {
                            node.setAttribute('data-ringpool-type2', tfn);
                        }
                    }
                });
                // only need to check first phone button if ringpool is loaded
                if (phoneButton !== null) {
                    phoneButton.dispatchEvent(new CustomEvent('ringPoolType2Loaded', {}));
                    console.log('Ringpool custom native typeid 2 numbers loaded...');
                }
            });
    }
};
